module.exports = __webpack_public_path__ + "img/img4.eea02e79.png";